import React from 'react';

import {
    Cutout
} from 'react95';

import About from '../About/about2.jpg'

export const SecondAbout = () => {
    return (
        <div className="container-fluid p-0">
            <div className="row no-gutters">
                <div className="col-md-4 col-12">
                    <Cutout >
                        <img
                            style={{ width: '100%', height: 'auto', display: 'block' }}
                            src={About}
                            alt='kiwi'
                        />
                    </Cutout>
                </div>
                <div className="col-md-8 col-12">
                    <p className="px-3 py-1">
                    My greatest passion is widely understood graphics, which I realize by making tattoos or murals.                            </p>
                    <p className="px-3">
                    Since childhood, I have been interested in the history of the 20th century because of it strong influence on today's reality and relations and social phenomena in today's Europe and world.                            </p>
                    <p className="px-3">
                    The last of my hobbies is motorization from the end of the twentieth century and one of my daily activities is browsing through car services. I honestly believe that one day I will have a Mercedes Sec 560 in my garage.                            </p>
                </div>

            </div>
        </div>
    );
}